<div class="login-container">
  <div class="login-card">
    <!-- Logo and Header -->
    <div class="login-header">
      <ukg-logo alt="UKG" class="brand-logo"></ukg-logo>
      <p class="app-subtitle">Pro Check Printing</p>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="error-alert">
        {{ errorMessage }}
      </div>
    }

    <!-- SSO Login Button -->
    <ukg-button
      emphasis="high"
      size="large"
      class="sso-button"
      [disabled]="loading"
      (click)="onSSOLogin()"
      (keydown.enter)="onSSOLogin()">
      Sign in with SSO
    </ukg-button>
  </div>
</div>

<!-- Footer -->
<footer class="login-footer">
  Copyright 2024 UKG Inc. All rights reserved.
</footer>
